<placeme-splash-mask [bgColorClass]="bgColorClass">
  <ng-lottie width="300px" height="300px" (enterFrame)="enterFrame($event)" [options]="lottieOptions"></ng-lottie>
</placeme-splash-mask>
